import { render, staticRenderFns } from "./TraxTrainingRatingCrudTable.vue?vue&type=template&id=1917794a"
import script from "./TraxTrainingRatingCrudTable.vue?vue&type=script&lang=js"
export * from "./TraxTrainingRatingCrudTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports